<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left :color="estado ? 'success' : 'warning'">
          {{ estado ? 'mdi-check-circle' : 'mdi-alert-circle' }}
        </v-icon>
        {{ estado ? 'Validar Proveedor' : 'Desvalidar Proveedor' }}
      </v-card-title>

      <v-card-text>
        <v-alert
          :type="estado ? 'green' : 'warning'"
          prominent
          text
          class="mb-4"
        >
          {{ mensajeAccion }}
        </v-alert>

        <div>
          <v-row dense>
            <v-col cols="12">
              <div class="text-subtitle-2 grey--text">Clave</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.clave || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">Nombre Completo</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.nombre_completo || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">RFC</div>
              <div class="text-body-1">
                {{ editedItem.rfc || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">Tipo de Proveedor</div>
              <div class="text-body-1">
                {{ editedItem.nombre_proveedor_tipo || 'N/A' }}
              </div>
            </v-col>
          </v-row>
        </div>

        <br>

        <div class="text-body-1">
          ¿Está seguro de realizar esta acción?
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          color="green"
          @click="cancelar"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="red"
          :loading="loading"
          :disabled="loading"
          @click="confirmar"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DialogoValidacionProveedor',
  
  data() {
    return {
      dialog: false,
      estado: null,
      loading: false,
      editedItem: {
        id_proveedor: null,
        clave: '',
        nombre_completo: '',
        rfc: '',
        nombre_proveedor_tipo: '',
      }
    }
  },

  computed: {
    mensajeAccion() {
      if (this.estado) {
        return 'Está a punto de VALIDAR este proveedor. Una vez validado, el proveedor será marcado como verificado en el sistema.';
      } else {
        return 'Está a punto de DESVALIDAR este proveedor. Esta acción removerá la marca de validación del proveedor.';
      }
    }
  },

  methods: {
    open(item, estado) {
      this.editedItem = Object.assign({}, item);
      this.estado = estado;
      this.dialog = true;
    },

    cancelar() {
      this.dialog = false;
      this.loading = false;
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.estado = null;
    },

    async confirmar() {
      if(this.estado == null) return;
      this.loading = true;
      
      axios
      .post('/Proveedores/CambiarValidacionProveedor', {
        id_proveedor: this.editedItem.id_proveedor,
        validar: this.estado
      })
      .then(() => {
        this.cancelar();
        this.$emit('change', null)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>